import { Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { HoldingSupplier } from '../../_models/holdingSupplier';
import { SupportGridview, SupportGridviewTableBodyCell, SupportGridviewTemplateCell } from 'app/support/_models/supportGridview';
import { PageChangeEvent } from 'app/support/_models/pageChangeEvent';

@Component({
    selector: 'app-holdings-list', templateUrl: './holdings-list.component.html', styleUrls: ['./holdings-list.component.scss'],
    standalone: false
})
export class SupportHoldingsListComponent {
    @ViewChild('isBillableTemplate') isBillableTemplate: TemplateRef<any>;
    @ViewChild('actionTemplate') actionTemplate: TemplateRef<any>;

    @Input() pageNumberController: number;
    @Input() totalHoldings: number;
    @Input() pageSize: number;
    @Output() editHolding = new EventEmitter<any>();
    @Output() pageChange = new EventEmitter<number>();

    private _holdings: HoldingSupplier[] = [];

    public config: SupportGridview = new SupportGridview();
    public templatesArray: SupportGridviewTemplateCell[] = [];

    constructor() { }

    ngOnInit(): void {
        this.config.set({
            actions: {
                edit: { enable: false },
                action: { enable: false },
                remove: { enable: false },
            },
            emptyText: { isHtml: false, value: 'support.manage-holdings.list.empty-list' },
            list: this.holdings,
            table: {
                body: [
                    new SupportGridviewTableBodyCell('col-0-25 text-center', 'holdingId'),
                    new SupportGridviewTableBodyCell('col-0-25 text-center', 'superlogicaId', 'nullable'),
                    new SupportGridviewTableBodyCell('col-2 truncate-gridview', 'name', 'string', null, null, true),
                    new SupportGridviewTableBodyCell('col', 'holdingTypeDescription'),
                    new SupportGridviewTableBodyCell('col-0-75', 'paymentTypeDescription'),
                    new SupportGridviewTableBodyCell('col-0-5', 'cashbackTypeDescription'),
                    new SupportGridviewTableBodyCell('col-0-5 text-center', 'isBillable', 'html', null, 'isBillableTemplate'),
                    new SupportGridviewTableBodyCell('col-0-25 text-center', 'isBillable', 'html', null, 'actionTemplate')
                ],
                header: [
                    { className: 'col col-0-25 text-center', value: 'support.manage-holdings.list.table-header.id' },
                    { className: 'col col-0-25 text-center', value: 'support.manage-holdings.list.table-header.superlogica-id' },
                    { className: 'col col-2', value: 'support.manage-holdings.list.table-header.name' },
                    { className: 'col', value: 'support.manage-holdings.list.table-header.type' },
                    { className: 'col col-0-75', value: 'support.manage-holdings.list.table-header.payment-type' },
                    { className: 'col col-0-5', value: 'support.manage-holdings.list.table-header.cashback' },
                    { className: 'col col-0-5 text-center', value: 'support.manage-holdings.list.table-header.is-billable' },
                    { className: 'col col-0-25 text-center', value: 'support.manage-holdings.list.table-header.actions' }
                ]
            }
        });
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.templatesArray = [
                { name: 'isBillableTemplate', template: this.isBillableTemplate },
                { name: 'actionTemplate', template: this.actionTemplate }
            ];
        })
    }

    selectHoldingToEdit(holding: any) {
        this.editHolding.emit(holding);
    }

    changePage($event: PageChangeEvent) {
        this.pageChange.emit($event.pageIndex);
    }

    @Input() get holdings(): HoldingSupplier[] { return this._holdings; }

    set holdings(value: HoldingSupplier[]) {
        this._holdings = value;
        this.config.list = value;
    }
}
